<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-800 relative"
            :class="{'required': required}"
            :for="name">
            {{ label }}
            <font-awesome-icon class="text-xs text-black ml-1 cursor-pointer"
                :icon="['fas', 'question-circle']"
                style="margin-top: 2px;"
                v-if="tooltip" v-tooltip="tooltip" />
        </label>
        <div class="mt-1 text-sm">
            <ValidationProvider :name="label" mode="lazy" :rules="rules" v-slot="{ errors }" tag="div" >
                <div :class="{ 'border border-red-600' : errors[0], 'opacity-50 cursor-not-allowed' : disabled }">
                    <ckeditor
                        @input="onInput"
                        v-model="model"
                        :editor="editor"
                        :config="editorConfig"
                    ></ckeditor>
                    <span class="text-xs text-red-700 absolute">{{ errors[0] }}</span>
                </div>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    import CKEditor from '@ckeditor/ckeditor5-vue';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    // import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';

    import axios from "axios";
    import _ from "lodash";

    class CustomUploadAdapter {
        constructor( loader, editor ) {
            this.loader = loader;
            this.editor = editor;
        }

        upload() {
            return new Promise( ( resolve, reject ) => {
                /**
                 * The following code were copied from CKEditor Official Adapter : Base64UploadAdapter.
                 * The link to the code can be found here https://github.com/ckeditor/ckeditor5-upload/blob/559459e5cd9c65fafcda558074c74eabba5fac0f/src/base64uploadadapter.js#L15-L26
                 */
                const reader = this.reader = new window.FileReader();

                reader.addEventListener( 'load', () => {
                    resolve( { default: reader.result } );
                } );

                reader.addEventListener( 'error', err => {
                    reject( err );
                } );

                reader.addEventListener( 'abort', () => {
                    reject();
                } );

                this.loader.file.then( file => {
                    reader.readAsDataURL( file );
                } );
            } );
            // return this.loader.file.then( file => new Promise( ( resolve, reject ) => {
            //     const axiosConfig = {
            //         headers: {'Content-Type': 'multipart/form-data'}
            //     };

            //     let formData = new FormData();
            //     formData.append('folder', 'tickets');
            //     formData.append('return', 'thumbnail');
            //     formData.append('file', file);

            //     axios.post(process.env.VUE_APP_API_URL + '/upload', formData, axiosConfig).then(response => {
            //         resolve({ default: response.data.data.url });
            //         this.editor.execute( 'imageStyle', { value: 'alignLeft' } );
            //     }).catch((error) => {
            //         reject(error.data.message);
            //     });
            // }));
        }
    }

    function MyCustomUploadAdapterPlugin( editor ) {
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
            return new CustomUploadAdapter( loader, editor );
        };
    }

    export default {
        name: "Editor",
        props: {
            label: { type: String, default: '' },
            value: { default: '' },
            initialValue: { default: '' },
            name: { type: String, default: '' },
            placeholder: { type: String, default: '' },
            readonly: { type: Boolean, default: false },
            rules: { type: String, default: '' },
            required: { type: Boolean, default: false },
            tooltip: { type: String, default: '' },
            disabled: { type: Boolean, default: false },
            debounce: { type: Boolean, default: false },
            delay: { type: Number, default: 2000 }
        },
        components: {
            ckeditor: CKEditor.component
        },
        data: function(){
            return {
                model: null,
                editor: ClassicEditor,
                editorConfig: {
                    extraPlugins: [
                        MyCustomUploadAdapterPlugin
                    ],
                    toolbar: [ 'bold', 'italic', 'link', 'BulletedList', 'NumberedList', '|', 'outdent', 'indent', '|', 'ImageUpload', 'blockquote', 'insertTable', '|', 'undo', 'redo' ],
                    // removePlugins: [ 'Image', 'ImageUpload', 'MediaEmbed', 'Heading' ],
                    // removePlugins: [ 'Heading' ],
                    // image: {
                    //     toolbar: [ 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
                    //     styles: [
                    //         'full',
                    //         'alignLeft',
                    //         'alignRight'
                    //     ]
                    // },
                    link: {
                        addTargetToExternalLinks: true,
                        decorators: {
                            addTargetToExternalLinks: {
                                mode: 'automatic',
                                callback: url => /^(https?:)?\/\//.test( url ),
                                attributes: {
                                    target: '_blank',
                                    rel: 'noopener noreferrer'
                                }
                            },
                            detectDownloadable: {
                                mode: 'automatic',
                                callback: url => url.endsWith( '.pdf' ),
                                attributes: {
                                    download: 'file.pdf'
                                }
                            }
                        }
                    },
                    height: 500,
                    extraAllowedContent: '*{*}',
                    allowedContent: true
                },
            }
        },
        beforeMount() {
            if (this.value){
                this.model = this.value;
            } else if (this.initialValue){
                this.model = this.initialValue;
            }
        },
        methods: {
            onInput (event) {
                if (this.deboucne) {
                    _.debounce(() => {
                        if (event.target) {
                            this.$emit('input', event.target.value);
                        } else {
                            // Used for Masked Input
                            this.$emit('input', event);
                        }
                    }, this.delay);
                } else {
                    if (event.target){
                        this.$emit('input', event.target.value);
                    } else {
                        // Used for Masked Input
                        this.$emit('input', event);
                    }
                }
            }
        },
        watch: {
            value: function(newVal){
                this.model = newVal;
                this.$emit('input', newVal);
            },
        }
    }
</script>

<style scoped>

</style>
